import { Octokit } from "octokit";

export const octokit = new Octokit({
  auth: process.env.VITE_GITHUB_ACCESS_TOKEN,
});
